import { render, staticRenderFns } from "./MyAccountButton.vue?vue&type=template&id=685f5bc5"
import script from "./MyAccountButton.vue?vue&type=script&lang=js"
export * from "./MyAccountButton.vue?vue&type=script&lang=js"
import style0 from "./MyAccountButton.vue?vue&type=style&index=0&id=685f5bc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports